import { render, staticRenderFns } from "./PriceAndPaidModal.vue?vue&type=template&id=113a8573&scoped=true"
import script from "./PriceAndPaidModal.vue?vue&type=script&lang=js"
export * from "./PriceAndPaidModal.vue?vue&type=script&lang=js"
import style0 from "./PriceAndPaidModal.vue?vue&type=style&index=0&id=113a8573&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113a8573",
  null
  
)

export default component.exports